/**
 * @file useHashScroll.ts
 * @description Прокрутка к якорю из адреса (`#agreement`) после того, как
 * блок появился (вынесено из `OrderDetailPage` в phase19.24 шаг 5.1).
 *
 * react-router к якорю не прокручивает сам, а блок карточки мог отрисоваться
 * уже после первого кадра — поэтому ждём признак «данные пришли» (`ready`), а
 * не только смену адреса.
 */

import { useEffect } from "react";
import { useLocation } from "react-router";

export function useHashScroll(ready: boolean): void {
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash || !ready) return;
    const el = document.getElementById(hash.slice(1));
    // В jsdom `scrollIntoView` не реализован — тесты не должны падать.
    if (el && typeof el.scrollIntoView === "function") {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [hash, ready]);
}
